'use client';

import { useCallback, useEffect } from 'react';
import { LoadingModal } from '../../../components/LoadingModal/LoadingModal';
import { useCoupon } from '@domain/premium/useCoupon';
import { Modal } from '../../../components/Modal/Modal';
import { reportMykissClientError } from '@lib/errors/client';
import { useRouter } from 'next/navigation';

const REDIRECT_DELAY = 2500; // 2.5 seconds

export const ProCouponLoadingModal = ({ couponCode }: { couponCode?: string }) => {
  const { isLoading: couponIsLoading, codeIsInvalid } = useCoupon(couponCode);
  const router = useRouter();

  const handleInvalidClose = useCallback(() => {
    try {
      router.push('/pro');
    } catch (error) {
      reportMykissClientError(error);
    }
  }, [router]);

  useEffect(() => {
    if (codeIsInvalid) {
      const timeout = setTimeout(() => {
        handleInvalidClose();
      }, REDIRECT_DELAY);

      return () => clearTimeout(timeout);
    }
    return undefined;
  }, [codeIsInvalid, handleInvalidClose]);

  if (couponCode && codeIsInvalid) {
    return (
      <Modal
        disableClose={{
          disableCloseButton: false,
          disableClickOutside: true,
          disableEscapeKey: true,
        }}
        closeButtonVariant="controlOnColorfulBg"
        isOpen
        onClose={handleInvalidClose}
        className="text-pinktail bg-pinktail-tint flex flex-col items-center justify-center pb-12"
        size="md"
      >
        <span className="font-semibold">The coupon code is not valid anymore</span>
      </Modal>
    );
  }

  return couponIsLoading ? <LoadingModal text="Coupon is loading..." isOpen={true} /> : <></>;
};
